import Page from "./Page";
import Pumpkins from "../Utils/Pumpkins";
import Template from "./Results.ejs";
import PumpkinResult from "./Components/PumpkinResult";
import PumpkinDetails from "./Components/PumpkinDetails";
import Events from "../Utils/EventLite";
import {CONFIG} from "../config";

export default class Results extends Page {
    constructor() {
        super(Template, {}, "Results");
        
        this.overlayContainer = document.createElement("div");
        this.overlayContainer.classList.add("overlay");
        this.backButton = this.element.getElementsByTagName("button")[0];
        this.backButton.addEventListener("click", ()=>{this.goBack()});
        this.element.appendChild(this.overlayContainer);
        this.overlay = null;
        this.results = [];

    }
    goBack() {
        Events.trigger("goto", "Story");
    }
    init(resolve, reject) {
        super.init(resolve, reject);
        this.selectionContainer = document.getElementById("voting-result-selections");
        this.showResults();
        window.setInterval(this.poll.bind(this), 20000);
        Events.on("showOverlay", this.showOverlay.bind(this));
        Events.trigger("stopMainMusic");
        //Events.trigger("playAmbientLoop");
    }
    showResults () {
        var Results = this;
        var pumpkins = new Pumpkins(CONFIG.year);
        pumpkins.get().then(function (values) {
            if(Results.results != undefined) {
                this.removeResults();
            }
            for (var i = 0; i < values.length; i++) {
                var selection = new PumpkinResult(values[i]);
                selection.addToParent(this.selectionContainer);
                this.results.push(selection);
            }
        }.bind(this));
    }
    poll(){
        this.showResults();
    }
    removeResults(){
        for (var i = 0; i < this.results.length; i++) {
            this.results[i].destroy();
        }
    }
    showOverlay(data) {
        ga('send', 'event', 'Show Details',data.Name);
        if(this.overlay != null) {
            this.overlay.destroy();
        }
        this.overlay = new PumpkinDetails(data);
        this.overlay.show();
        this.overlay.addToParent(this.overlayContainer);
    }
}



// WEBPACK FOOTER //
// ./src/views/Results.js